export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6721.e57d6f41.jpg";